import React, { useState } from "react";
import { fmtDateTime } from "../lib/dates";
import { MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "../lib/api";
import { useApi } from "../hooks/useApi";
import { Button } from "./ui/button";

export const SmsHealth = () => {
  const { data, reload } = useApi("/admin/sms-health");
  const [busy, setBusy] = useState(false);
  const sendTest = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/sms-health/test");
      if (r.status === "sent") toast.success(`Test SMS sent to ${r.to}`);
      else if (r.status === "no_phone") toast.error("Add a phone number to your profile first");
      else if (r.status === "unconfigured") toast.error(`SMS not configured — missing ${r.missing.join(", ")}`);
      else toast.error(`SMS failed: ${r.error}`);
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); reload(); }
  };
  return (
    <div className="glass rounded-2xl p-6 space-y-3" data-testid="sms-health">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-serif-display text-xl font-bold text-palm"><MessageSquare size={18} /> SMS delivery (Twilio)</h3>
        <Button size="sm" onClick={sendTest} disabled={busy} className="bg-crimson" data-testid="sms-test-btn"><Send size={14} className="mr-1" /> Send me a test SMS</Button>
      </div>
      {data && (
        <p className="text-sm text-muted-foreground" data-testid="sms-config">
          {data.configured ? `Connected · Sending from ${data.from_number}` : `Not configured · missing ${data.missing.join(", ")}`}
          {" · "}{data.sent} sent · {data.failed} failed · {data.queued} queued
        </p>
      )}
      {data?.last?.error?.includes("predefined SMS templates") && (
        <p className="rounded-lg border border-amber-400 bg-amber-50 p-3 text-xs text-amber-900" data-testid="sms-trial-warning">
          <strong>Twilio trial limitation:</strong> trial accounts can only send Twilio's own template texts, so custom messages are rejected. To send real SMS, upgrade the Twilio account (Console → Billing → add a payment method). No code change needed afterwards.
        </p>
      )}
      {data?.last && <p className="text-xs text-muted-foreground" data-testid="sms-last">Last: {data.last.status} to {data.last.to} at {fmtDateTime(data.last.created_at)}{data.last.error ? ` — ${data.last.error}` : ""}</p>}
    </div>
  );
};
